import React from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';

const ParentTable= ({ 
  parents, 
  lazyParams, 
  totalRecords, 
  loading, 
  onPage, 
  onSort,
  onFilter, 
  expandedRows, 
  onRowToggle, 
  openEditDialog, 
  deleteClass
}) => {
  

  const actionBody = (rowData) => (
    <div className="flex items-center gap-2">
      <Button icon="pi pi-pencil" className="p-button-rounded p-button-text p-button-sm hover:bg-green-50 text-green-600 border-2 border-green-200 hover:border-green-300 transition-all duration-200"
        onClick={() => openEditDialog(rowData)} tooltip="Edit Class" />
      <Button icon="pi pi-trash" className="p-button-rounded p-button-text p-button-sm hover:bg-red-50 text-red-600 border-2 border-red-200 hover:border-red-300 transition-all duration-200"
        onClick={() => deleteClass(rowData)} tooltip="Delete Class" />
    </div>
  );

  return (
 <DataTable value={parents} lazy dataKey="id" paginator first={lazyParams.first} rows={lazyParams.rows}
      totalRecords={totalRecords} onFilter={onFilter} expandedRows={expandedRows} onRowToggle={onRowToggle} onPage={onPage} onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder} loading={loading}
      loadingIcon="pi pi-spin pi-spinner"
      emptyMessage={<div className="text-center py-8">No Parents found</div>} rowsPerPageOptions={[5, 10, 25, 50]}
      paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} students" responsiveLayout="scroll" showGridlines stripedRows size="small">
       
        <Column field="name" header=" Name" sortable />
        <Column field="phone" header="MobileNo" />
        <Column field="email" header="Email" />
        <Column field="address" header="Address" />
        <Column body={actionBody} header="Actions" style={{ width: 150 }} />

    </DataTable>

  );
};

export default ParentTable;